import React from 'react'

const CustmrFocus = () => {
  return (
    <div className="fabrication-container">
      <div className="fabrication-text">
        <h2 className="fabrication-heading">
          <span className="highlight">Customer Focus</span>
        </h2>
        <p>
     At Automotive Devices, we believe that every customer deserves exceptional service tailored to their unique needs. Our commitment to customer focus is reflected in every aspect of our operations—from flexible project management and responsive communication to delivering efficient, high-quality PCBA solutions.

We collaborate closely with you at every stage of the process, ensuring your requirements are met with accuracy, attention to detail, and care. By fostering open communication and a problem-solving mindset, we adapt to your evolving needs and help you navigate even the most complex manufacturing challenges.

With a strong dedication to building long-term partnerships, we are here to support your success every step of the way. At Automotive Devices, your goals are our mission—and your satisfaction is our top priority.


        </p>
      </div>

      <div className="fabrication-image" style={{ marginTop: '100px' }}>
        <img src="/customer focus.jpeg" alt="PCB Fabrication Services" />
      </div>
    </div>
  )
}

export default CustmrFocus
